import React, { Component } from 'react';
import { Select } from 'antd';

import t from '../i18n'



export const VariantList = (props) => {
  function handleChange(selectedValues, selectedObjects) {
    const values = selectedObjects.map(obj => parseInt(obj.key));
    console.log(`selected ${values}`);
    let variants = props.variantList;
    if (values) {
      variants = variants.filter((v) => values.includes(v.id));
    }
    props.VariantChanged(variants);
  }
  const children = [];
  props.variantList.forEach((v, index) => {
    children.push(<Option value={`${v.name}-${v.id}`} key={v.id}> {v.name} </Option>);
  });
  // for (let i = 10; i < 36; i++) {
  //   children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
  // }
  return (<Select showSearch mode="multiple" style={{ width: '100%' }} placeholder={t('item')} onChange={handleChange}>
    {children}
  </Select>);
};
